import React from 'react';
import { MdOpenInNew } from 'react-icons/md';
import { useOrganizationBranding } from './hooks';
import StatusBadge from '../ReusableComponents/StatusBadge';
export default function OrganizationModuleRow() {
  const q = useOrganizationBranding(),
    o = q.data;
  if (!o?.portal_enabled) return null;
  return (
    <tr>
      <td>Inscrições</td>
      <td>Portal de inscrições, documentos e acompanhamento dos candidatos</td>
      <td>
        <StatusBadge variant="success">Ativo</StatusBadge>
      </td>
      <td>—</td>
      <td className="hidethis">
        {o.portal_frontend_url && (
          <a
            className="btn btn-primary system-module-access"
            href={o.portal_frontend_url}
            target="_blank"
            rel="noopener noreferrer"
          >
            Acessar <MdOpenInNew />
          </a>
        )}
      </td>
    </tr>
  );
}
